var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: "", visible: _vm.visible, width: "500px" },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: function ($event) {
          _vm.visible = false
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "login-form",
          staticStyle: { "padding-top": "0" },
          attrs: { model: _vm.dataForm, "label-width": "80px" },
        },
        [
          _c("div", { staticClass: "title-container text-center" }, [
            _c("img", {
              staticStyle: { filter: "brightness(5)" },
              attrs: {
                src: require("@/assets/images/logo.png"),
                width: "150",
                alt: "",
              },
            }),
            _c("h3", { staticStyle: { color: "white" } }, [
              _vm._v("Reset password"),
            ]),
          ]),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "30px", "margin-top": "3em" } },
            [
              _c("p", { staticStyle: { color: "white" } }, [
                _vm._v("Enter the OTP code sent to your email"),
              ]),
              _c(
                "div",
                [
                  _c("OtpInput", {
                    ref: "otpInput",
                    staticClass: "otpInputElm",
                    attrs: {
                      "input-classes": "otp-input",
                      separator: "-",
                      "num-inputs": 4,
                      "should-auto-focus": true,
                      "is-input-num": true,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "", prop: "password" } },
            [
              _c(
                "span",
                { staticClass: "svg-container" },
                [_c("svg-icon", { attrs: { "icon-class": "password" } })],
                1
              ),
              _c("el-input", {
                attrs: { type: "password", placeholder: "Input new password" },
                model: {
                  value: _vm.dataForm.password,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.dataForm,
                      "password",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "dataForm.password",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "", prop: "rePassword" } },
            [
              _c(
                "span",
                { staticClass: "svg-container" },
                [_c("svg-icon", { attrs: { "icon-class": "password" } })],
                1
              ),
              _c("el-input", {
                attrs: {
                  type: "password",
                  placeholder: "Input renew password",
                },
                model: {
                  value: _vm.dataForm.rePassword,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.dataForm,
                      "rePassword",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "dataForm.rePassword",
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { width: "100%", "margin-bottom": "30px" },
              attrs: { loading: _vm.loading, type: "primary" },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleSubmit($event)
                },
              },
            },
            [_vm._v("Submit")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }